import { Button, Modal } from "../../../../../../components";
import { useBoolean } from "../../../../../../hooks";
import { ClaimAllRewardsBody } from "./ClaimAllRewardsBody";

type ClaimAllRewardsProps = {
  onClaimSuccess: () => void;
};

export const ClaimAllRewards = ({ onClaimSuccess }: ClaimAllRewardsProps) => {
  const [isModalOpen, openModal, closeModal] = useBoolean();

  return (
    <>
      <Button.Primary
        style={{ padding: "10px 20px", marginTop: "3px" }}
        onClick={openModal}
      >
        Claim all rewards
      </Button.Primary>
      <Modal
        title="Claim all rewards"
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <ClaimAllRewardsBody
          onClaimSuccess={() => {
            onClaimSuccess();
            closeModal();
          }}
        />
      </Modal>
    </>
  );
};
